// src/utils/tokenStorage.ts

export const getAccessToken = (): string | null => localStorage.getItem('admin_access_token');
export const getRefreshToken = (): string | null => localStorage.getItem('admin_refresh_token');

export const setToken = (accessToken: string, refreshToken: string) => {
  localStorage.setItem('admin_access_token', accessToken);
  localStorage.setItem('admin_refresh_token', refreshToken);
};

export const clearToken = () => {
  localStorage.removeItem('admin_access_token');
  localStorage.removeItem('admin_refresh_token');
};